import { render, staticRenderFns } from "./table_skeleton.vue?vue&type=template&id=d767f246&scoped=true&"
import script from "./table_skeleton.vue?vue&type=script&lang=js&"
export * from "./table_skeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d767f246",
  null
  
)

export default component.exports